/**
 * MKS-464 — TanStack Query hook for /api/manager/delivery.
 *
 * Query key `['manager', 'delivery', period]`; 60 s `staleTime` mirrors usePortfolioOverview so
 * flipping between the two Manager overview tabs does not re-hit the database on every switch.
 */
import { useQuery } from '@tanstack/react-query';
import {
  fetchDeliveryOverview,
  type DeliveryOverview,
  type DeliveryPeriodKey,
} from '../services/api/delivery';

export type { DeliveryPeriodKey };

export function useDeliveryOverview(period: DeliveryPeriodKey) {
  return useQuery<DeliveryOverview>({
    queryKey: ['manager', 'delivery', period],
    queryFn: () => fetchDeliveryOverview(period),
    staleTime: 60_000,
  });
}
